import {Link, Skeleton} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import * as React from "react";
import {FC} from "react";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";
import {getRandomNumber} from "../../../util/utils";

interface IProps {
    company: string
    companyUrl: string | null
    color: string
    sx?: SxProps<Theme>
    loading?: boolean
}

const CompanyLabel: FC<IProps> = (props) => {
    const handleClickCompany = (e: any) => {
        e.stopPropagation()
    }

    const companyUrlNormalized = /^https?:\/\//.test(props.companyUrl!) ? props.companyUrl! : `https://${props.companyUrl}`;

    if (props.loading) {
        return <Grid container justifyContent="center">
            <Skeleton width={`${getRandomNumber(100, 150)}px`} animation='wave'/>
        </Grid>
    }

    return props.companyUrl ? <Link sx={{
            cursor: "pointer",
            color: props.color,
            textAlign: 'center',
            display: 'block',
            fontSize: '0.875rem',
            width: 'fit-content', ...props.sx
        }} onClick={handleClickCompany}
                                    href={companyUrlNormalized} target="_blank" rel="noopener noreferrer">
            {props.company}
        </Link> :
        <Typography variant="body2" color={props.color} textAlign='center' sx={{...props.sx}}>
            {props.company}
        </Typography>
}

export default CompanyLabel